import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideo } from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import styles from '../Meeting.module.scss'

const WebinarBanner = ({ startTime, endTime }) => {
  const t = useTranslationRankmi({
    prefix: 'lessons.contentBlocks.meetingBlock.webinarBadge',
  })

  return (
    <div className={styles.webinarContainer}>
      <div className={styles.webinarBanner}>
        <FontAwesomeIcon icon={faVideo} className={styles.webinarIcon} />
        <div className={styles.webinarText}>
          <span className={styles.webinarTextBold}>
            {t('webinarTextBold')} {''}
          </span>
          <span className={styles.webinarTextRegular}>
            {t('webinarTextRegular', {
              startTime: startTime,
              endTime: endTime,
            })}
          </span>
        </div>
      </div>
    </div>
  )
}

export default WebinarBanner
